// ignore-string-externalization

import React from 'react';
import { ModuleType } from '../types';

import { ContentGrid } from '../../ContentGrid';

type EditorialGridModuleType = ModuleType & {
  headline?: string;
  subtext?: string;
  items?: any[];
  ctaText?: string;
  ctaLink?: string;
};

export const EditorialGridModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  EditorialGridModuleType
>(({ id, headline, subtext, items = [], ctaText, ctaLink }, ref) => {
  return (
    <ContentGrid
      ref={ref}
      trackCategory="module-editorialGrid"
      data-testid={`editorial-grid-module-${id}`}
      headline={headline}
      subtext={subtext}
      items={items}
      featuredItems={2}
      ctaText={ctaText}
      ctaLink={ctaLink}
    />
  );
});
